// Lib
import React, { useEffect, useState } from 'react'
import { withFormik, useFormikContext } from 'formik'
import { useNavigate } from 'react-router-dom'
import { useMsal } from '@azure/msal-react'
import jwt_decode from 'jwt-decode'
import _ from 'lodash'

// Images
import photoSidePNG from 'images/Login/loginNav.png'

// Include in project
import styles from './index.module.scss'
import { FormLogin } from 'container'
import useLogin from 'hooks/api/uselogin'
import yupLogin from 'validations/yupLogin.validate'
import { checkIfAzureEmail } from 'utils/other'
import { loginRequest } from 'config/azure'
import useScgLogin from 'hooks/api/useScgLogin'

const Login: React.FC = () => {
  const navigate = useNavigate()
  const { values, setFieldValue, errors } = useFormikContext<{ email: string; password: string; remember: string[] }>()
  const [isShowInputPassword, setIsShowInputPassword] = useState(false)

  useEffect(() => {
    const email = localStorage.getItem('email')
    const password = localStorage.getItem('password')
    if (!email || !password) return

    setFieldValue('email', email)
    setFieldValue('password', password)
    setFieldValue('remember', ['remember'])
  }, [])

  function getTimestampInSecondsPlusOneDay() {
    const date = new Date()
    date.setDate(date.getDate() + 1)
    return `${date.getTime()}`
  }

  const { login } = useLogin((response) => {
    if (values.remember.length === 1) {
      localStorage.removeItem('expiredLogin')
      localStorage.setItem('email', values.email)
      localStorage.setItem('password', values.password)
    }
    if (values.remember.length === 0) {
      localStorage.setItem('expiredLogin', getTimestampInSecondsPlusOneDay())
      localStorage.removeItem('email')
      localStorage.removeItem('password')
    }

    localStorage.setItem('accessToken', response.data.accessToken)
    localStorage.setItem('refreshToken', response.data.refreshToken)

    navigate('/')
  })

  const { scgLogin } = useScgLogin((response) => {
    if (values.remember.length === 1) {
      localStorage.removeItem('expiredLogin')
      localStorage.setItem('email', values.email)
    }
    if (values.remember.length === 0) {
      localStorage.setItem('expiredLogin', getTimestampInSecondsPlusOneDay())
      localStorage.removeItem('email')
    }

    localStorage.setItem('accessToken', response.data.accessToken)
    localStorage.setItem('refreshToken', response.data.refreshToken)

    navigate('/')
  })

  const handleSubmitLogin = async () => {
    if (!_.isEmpty(errors)) return

    const packData = {
      email: values.email,
      password: values.password,
    }
    login(packData)
  }

  const { instance } = useMsal()
  const handleScgLogin = async () => {
    instance
      .loginPopup(loginRequest)
      .then((res) => {
        const decode: { upn: string } = jwt_decode(res.accessToken)

        const packData = {
          email: decode.upn,
        }

        scgLogin(packData)
      })
      .catch((err) => {
        console.log('err', err)
      })
  }

  const isSCG = checkIfAzureEmail(values?.email)

  const handleShowInputPassword = () => {
    setIsShowInputPassword(!isShowInputPassword)
  }

  return (
    <div className={styles.container}>
      <section className={styles.wrapperInput}>
        <FormLogin
          handleSubmitLogin={isSCG ? handleScgLogin : handleSubmitLogin}
          handleShowInputPassword={handleShowInputPassword}
          isShowInputPassword={isShowInputPassword}
        />
      </section>
      <section className={styles.wrapperImg}>
        <img src={photoSidePNG} alt="photoSidePNG" />
      </section>
    </div>
  )
}

const EnhancedLogin = withFormik({
  mapPropsToValues: () => ({
    email: '',
    password: '',
    remember: [],
  }),
  validationSchema: yupLogin,
  handleSubmit: () => {
    console.log('SKIP')
  },
})(Login)
export default EnhancedLogin
